import { render, staticRenderFns } from "./EditorMenuTrack.vue?vue&type=template&id=896154c0&"
import script from "./EditorMenuTrack.vue?vue&type=script&lang=js&"
export * from "./EditorMenuTrack.vue?vue&type=script&lang=js&"
import style0 from "./EditorMenuTrack.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports